import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Stack, Typography, useMediaQuery } from "@mui/material";
import { MatchState } from '../Types';
// @ts-ignore
const LetterBoxComponent = ({ letterBox }) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const letterSideDimension = isMobile ? "9px" : "28px";
    const fontSize = isMobile ? "14px" : "21px";
    const green = "#6aaa64";
    const yellow = "#c9b458";
    const gray = "#787c7e";
    const white = "#ffffff";
    const black = "#000000";
    const maroon = "#ce4747";
    let backgroundColor = white;
    let foregroundColor = white;
    let borderColor = gray;
    if (letterBox.state === MatchState.matches) {
        backgroundColor = green;
        borderColor = green;
        foregroundColor = white;
    }
    else if (letterBox.state === MatchState.exists) {
        backgroundColor = yellow;
        borderColor = yellow;
        foregroundColor = white;
    }
    else if (letterBox.state === MatchState.nomatch) {
        backgroundColor = gray;
        borderColor = gray;
        foregroundColor = white;
    }
    else if (letterBox.state === MatchState.invalidWord) {
        backgroundColor = white;
        borderColor = gray;
        foregroundColor = maroon;
    }
    else {
        backgroundColor = white;
        foregroundColor = black;
    }
    return (_jsx(Box, { sx: {
            border: "1px solid",
            borderRadius: "4px",
            borderColor,
            padding: "10px",
            margin: "2px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: letterSideDimension,
            height: letterSideDimension,
            bgcolor: backgroundColor,
        }, children: _jsx(Typography, { textTransform: "uppercase", sx: {
                fontWeight: "bold",
                fontSize: fontSize,
                color: foregroundColor,
            }, children: letterBox.letter }) }));
};
const WordRowComponent = ({ letterBoxes }) => {
    let key = 0;
    const letterBoxComponents = letterBoxes.map((letterBox) => {
        key++;
        return _jsx(LetterBoxComponent, { letterBox: letterBox }, key);
    });
    return (_jsx(Stack, { direction: "row", children: letterBoxComponents }));
};
export default WordRowComponent;
